import { render, staticRenderFns } from "./CourseSatisfactionConf.vue?vue&type=template&id=28637d8b"
import script from "./CourseSatisfactionConf.vue?vue&type=script&lang=js"
export * from "./CourseSatisfactionConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports